
import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

const mentorshipImages = [
  "https://images.unsplash.com/photo-1522202176988-66273c2fd55f?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80", // Team collaboration
  "https://images.unsplash.com/photo-1531482615713-2afd69097998?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80", // Teaching/mentoring
  "https://images.unsplash.com/photo-1552664730-d307ca884978?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80", // Group meeting
  
  "https://images.unsplash.com/photo-1573164713988-8665fc963095?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80", // Business consultation
  "https://images.unsplash.com/photo-1556761175-5973dc0f32e7?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80"  // Learning environment
];

const Mentorship = () => {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImageIndex((prevIndex) => 
        prevIndex === mentorshipImages.length - 1 ? 0 : prevIndex + 1
      );
    }, 12000); // 12 seconds = 12,000 milliseconds

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      {/* Hero Section with animated mentorship images */}
      <section className="relative py-16 overflow-hidden">
        {/* Animated background images */}
        <div className="absolute inset-0">
          {mentorshipImages.map((image, index) => (
            <div
              key={index}
              className={`absolute inset-0 bg-cover bg-center transition-all duration-1000 ${
                index === currentImageIndex ? 'opacity-100 transform translate-x-0' : 'opacity-0 transform translate-x-full'
              }`}
              style={{ backgroundImage: `url('${image}')` }}
            />
          ))}
        </div>
        
        <div className="relative z-10 h-full flex items-center justify-center">
          <div className="max-w-4xl mx-auto px-4 md:px-8 text-center">
            <h1 className="text-5xl md:text-6xl font-bold text-white mb-4 drop-shadow-lg">
              Law and Code Africa Mentorship
            </h1>
          </div>
        </div>
        
        {/* Dark overlay for better text readability */}
        <div className="absolute inset-0 bg-black/30 z-0"></div>
      </section>

      {/* About Our Programme Section */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-6xl mx-auto px-4 md:px-8">
          <div>
            <h2 className="text-3xl font-bold text-primary mb-6">About Our Programme</h2>
            <div className="space-y-4 text-gray-700 text-lg leading-relaxed">
              <p>
                Law and Code Africa is committed to nurturing the next generation of legal professionals 
                who will shape the future of law and technology on the continent.
              </p>
              <p>
                Our mentorship programme provides young lawyers, law students, and aspiring legal technologists 
                with the knowledge, skills, and networks needed to thrive at the intersection of law, 
                artificial intelligence, and emerging technologies.
              </p>
              <p>
                Through structured guidance, practical training, and hands-on experience, we equip mentees 
                to navigate complex legal challenges in the digital age and become leaders in tech law.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Mentorship Focus */}
      <section className="py-16">
        <div className="max-w-4xl mx-auto px-4 md:px-8">
          <h2 className="text-3xl font-bold text-primary text-center mb-10">Mentorship Focus Areas</h2>
          <div className="space-y-6 text-lg text-muted-foreground leading-relaxed">
            <p>
              <span className="font-semibold text-foreground">AI Ethics & Compliance</span> — Navigate the ethical implications of AI systems and ensure compliance with emerging regulatory frameworks.
            </p>
            <p>
              <span className="font-semibold text-foreground">Legal Technology</span> — Explore how technology is transforming legal practice and the regulatory challenges it presents.
            </p>
            <p>
              <span className="font-semibold text-foreground">Digital Dispute Resolution</span> — Learn about ADR principles and how they apply to disputes in the digital age and AI-related conflicts.
            </p>
          </div>
        </div>
      </section>

      {/* Contact/Connect Section */}
      <section className="py-16 bg-gradient-to-r from-primary to-secondary">
        <div className="max-w-4xl mx-auto px-4 md:px-8 text-center">
          <h2 className="text-3xl font-bold text-white mb-6">Let's Connect</h2>
          <p className="text-xl text-blue-100 mb-8">
            Are you a young lawyer, law student, or aspiring legal technologist? Join our mentorship programme 
            and be part of shaping the future of law and technology in Africa.
          </p>
          <div className="flex justify-center">
            <Link 
              to="/mentorship-application"
              className="bg-white hover:bg-gray-100 text-primary px-8 py-3 rounded-full font-semibold text-lg transition-all duration-300 hover:shadow-lg transform hover:-translate-y-1"
            >
              Apply Now
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Mentorship;
